// StripeSuccess.jsx
import React, { useEffect, useRef, useState, useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { SyncOutlined } from '@ant-design/icons';
import { UserContext } from '../context';
import './StripeSuccess.css';

const StripeSuccess = ({ isLoggedIn }) => {
  const [state, , actions] = useContext(UserContext);
  const [readyToRedirect, setReadyToRedirect] = useState(false);
  const started = useRef(false);        // Avoid double-start in React Strict Mode
  const cancelRef = useRef(false);

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
  }, []);

  useEffect(() => {
    // Wait until the provider says it's ready and we have a token.
    if (!isLoggedIn || !state.ready || !state.auth || started.current) return;
    started.current = true;

    const maxMs = 60_000;
    const start = Date.now();

    const poll = async (attempt = 0) => {
      if (cancelRef.current) return;

      try {
        const fresh = await actions.refreshUser(); // fetches /api/users/:id?_ts=...
        // console.debug('[StripeSuccess poll] fresh?.active =', fresh?.active, fresh);
        if (fresh?.active) {
          if (!cancelRef.current) setReadyToRedirect(true);
          return;
        }
      } catch {
        /* ignore transient errors */
      }

      if (Date.now() - start > maxMs) {
        if (!cancelRef.current) setReadyToRedirect(true);
        return;
      }

      const delay = Math.min(1000 * Math.pow(1.5, attempt), 5000);
      setTimeout(() => poll(attempt + 1), delay);
    };

    poll();
    return () => { cancelRef.current = true; };
  }, [isLoggedIn, state.ready, state.auth, actions]);

  if (!isLoggedIn) return <Navigate to="/" replace />;
  if (readyToRedirect) return <Navigate to="/account" replace />;

  return (
    <div className="ss-overlay" role="status" aria-live="polite">
      <section className="ss-card">
        <SyncOutlined spin className="ss-spinner" aria-hidden />
        <h1 className="ss-title">Estamos activando tu suscripción.</h1>
        <p className="ss-sub">Esto puede tomar unos segundos.</p>
        <p className="ss-hint">Te redirigiremos automáticamente.</p>
      </section>
    </div>
  );
};

export default StripeSuccess;
